/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { format } from "date-fns";
import { useSelector } from "react-redux";
import {
  getMembershipCoverageMinDate,
  getMembershipCoverageMaxDate,
  servicesRequireMembership,
} from "../utils/membershipGrant";

/**
 * Coverage window for the chosen membership(s), plus the first-available-day
 * params for it. Needed because the backend's check_membership flag only sees
 * ALL of the client's memberships, not the one picked in the widget.
 */
export const useMembershipCoverage = (services) => {
  const membershipAccessGrants = useSelector((state) => state.booking.membershipAccessGrants);
  const today = format(new Date(), "yyyy-MM-dd");

  const minDate = getMembershipCoverageMinDate(services, membershipAccessGrants, today);
  const maxDate = getMembershipCoverageMaxDate(services, membershipAccessGrants);

  const availabilityParams = {
    ...(servicesRequireMembership(services) && { check_membership: true }),
    ...(minDate && { start_datetime: `${minDate} 00:00:00` }),
  };

  const clampDay = (day) => (maxDate && day > maxDate ? null : day);

  return { minDate, maxDate, availabilityParams, clampDay };
};
